export const environment = {
	version: "1.0.1",
	environment: 'Produção',
	production: '<ENVPRODUCTION>',
	url: 'https://api.personalizeseuape.com.br'
};
